import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';
import { ConfirmationModal } from '@issuemanager/apps/client/components';
import { useReassignIssueOwnerRequest } from '../hooks/use-reassign-issue-owner-request';
import { useIssueOutletContext } from '../../issue/hooks/useIssueOutletContext';

type Props = {
  open: boolean;
  onClose: () => void;
};

function ConfirmReassignmentRequestDialog({ open, onClose }: Props) {
  const { t } = useTranslation('issue');
  const { enqueueSnackbar } = useSnackbar();
  const { code } = useIssueOutletContext();

  const handleRequestSuccess = () => {
    onClose();
    enqueueSnackbar(t('view.requestReassignment.modal.success'), {
      variant: 'success',
    });
  };

  const reassignIssueRequest = useReassignIssueOwnerRequest({
    code,
    onSuccess: handleRequestSuccess,
  });

  return (
    <ConfirmationModal
      isOpen={open}
      title={t('view.requestReassignment.modal.title')}
      description={
        <Typography variant='body1'>
          {t('view.requestReassignment.modal.issueOwner.message')}
        </Typography>
      }
      acceptButtonProps={{
        text: reassignIssueRequest.isPending
          ? t('view.requestReassignment.modal.requesting')
          : t('view.requestReassignment.modal.request'),
        loading: reassignIssueRequest.isPending,
      }}
      cancelButtonProps={{
        text: t('view.requestReassignment.modal.cancel'),
        variant: 'text',
      }}
      onAccept={reassignIssueRequest.mutateAsync}
      onCancel={onClose}
    />
  );
}

export default ConfirmReassignmentRequestDialog;
